var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartImageSelected = function SvgPartImageSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 8.87.625 4.665c.125-.133.258-.258.422-.352L7.109.822a1.7 1.7 0 0 1 1.782 0l6.054 3.492c.164.094.305.22.422.344zm.648 1.155 7.188-4.093v6.93a1.74 1.74 0 0 1-.89 1.538L8.89 17.908c-.086.047-.164.094-.243.117zm-1.304 0v8c-.086-.023-.157-.078-.235-.117L1.047 14.4a1.74 1.74 0 0 1-.89-1.539V5.94z"
  })));
};
export default SvgPartImageSelected;